var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "text": "Please Wait. It may take a while for large number of records",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Tariff Card Template")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Tariff Card List"
    },
    on: {
      "click": _vm.showCreateTariffCard
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size:18px"
    }
  })])])])])]), _vm._v(" "), _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Tariff Card Template Name "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-credit-card'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tariffcardName),
      expression: "tariffcardName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "tariffcardName",
      "id": "tariffcardName",
      "placeholder": "Tariff Card Name"
    },
    domProps: {
      "value": (_vm.tariffcardName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tariffcardName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tariffcardName')),
      expression: "errors.has('tariffcardName')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter Tariff Card Name.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Tariff Card Template Description")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tariffcardDescription),
      expression: "tariffcardDescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: false
      }),
      expression: "{required: false}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('tariffcardDescription')
    },
    attrs: {
      "name": "tariffcardDescription",
      "placeholder": "Tariff Card Description"
    },
    domProps: {
      "value": (_vm.tariffcardDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tariffcardDescription = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tariffcardDescription')),
      expression: "errors.has('tariffcardDescription')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter Tariff Card Description.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row mt-2"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Route mode "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeMode),
      expression: "routeMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('routeMode')
    },
    attrs: {
      "type": "radio",
      "id": "Surface",
      "value": "Surface",
      "name": "routeMode"
    },
    domProps: {
      "checked": _vm._q(_vm.routeMode, "Surface")
    },
    on: {
      "change": _vm.changeRoute,
      "__c": function($event) {
        _vm.routeMode = "Surface"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Surface"
    }
  }, [_vm._v("Surface")]), _vm._v("   \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routeMode),
      expression: "routeMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('routeMode')
    },
    attrs: {
      "type": "radio",
      "id": "Air",
      "value": "Air",
      "name": "routeMode"
    },
    domProps: {
      "checked": _vm._q(_vm.routeMode, "Air")
    },
    on: {
      "change": _vm.changeRoute,
      "__c": function($event) {
        _vm.routeMode = "Air"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Air"
    }
  }, [_vm._v("Air ")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('routeMode')),
      expression: "errors.has('routeMode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Tariff Card Rate Basis.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servicetype),
      expression: "servicetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Service Type",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.servicetype, "1")
    },
    on: {
      "change": _vm.changeServiceType,
      "__c": function($event) {
        _vm.servicetype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("City to City    ")])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.servicetype),
      expression: "servicetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "name": "Service Type",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.servicetype, "2")
    },
    on: {
      "change": _vm.changeServiceType,
      "__c": function($event) {
        _vm.servicetype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Zone to Zone")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Service Type')),
      expression: "errors.has('Service Type')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select serivce type.")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row mt-3"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Service Level Template Name "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "name": "Service",
      "options": _vm.servicelist,
      "placeholder": "Select Service",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.selectservice
    },
    model: {
      value: (_vm.selectedservice.id),
      callback: function($$v) {
        _vm.selectedservice.id = $$v
      },
      expression: "selectedservice.id"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Service')),
      expression: "errors.has('Service')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select Service Level Template.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Rate Basis "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tariffcardratebasis),
      expression: "tariffcardratebasis"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Weight",
      "value": "1",
      "name": "tariffcardratebasis",
      "disabled": _vm.selectedservice.id == null
    },
    domProps: {
      "checked": _vm._q(_vm.tariffcardratebasis, "1")
    },
    on: {
      "change": _vm.resetData,
      "__c": function($event) {
        _vm.tariffcardratebasis = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Weight"
    }
  }, [_vm._v("Weight (kg)")]), _vm._v("   \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tariffcardratebasis),
      expression: "tariffcardratebasis"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "Quantity",
      "value": "2",
      "name": "tariffcardratebasis",
      "disabled": _vm.selectedservice.id == null
    },
    domProps: {
      "checked": _vm._q(_vm.tariffcardratebasis, "2")
    },
    on: {
      "change": _vm.resetData,
      "__c": function($event) {
        _vm.tariffcardratebasis = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Quantity"
    }
  }, [_vm._v("Quantity (Number of boxes)")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tariffcardratebasis')),
      expression: "errors.has('tariffcardratebasis')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Tariff Card Rate Basis.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Tariff Card Rate Type "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratetype),
      expression: "ratetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ratetype')
    },
    attrs: {
      "type": "radio",
      "name": "ratetype",
      "value": "flat",
      "disabled": _vm.selectedservice.id == null
    },
    domProps: {
      "checked": _vm._q(_vm.ratetype, "flat")
    },
    on: {
      "change": function($event) {
        _vm.showSlabWiseInput()
      },
      "__c": function($event) {
        _vm.ratetype = "flat"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Flat Rate")]), _vm._v("   \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ratetype),
      expression: "ratetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ratetype')
    },
    attrs: {
      "type": "radio",
      "name": "ratetype",
      "value": "slab",
      "disabled": _vm.selectedservice.id == null
    },
    domProps: {
      "checked": _vm._q(_vm.ratetype, "slab")
    },
    on: {
      "change": function($event) {
        _vm.showSlabWiseInput()
      },
      "__c": function($event) {
        _vm.ratetype = "slab"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Commercial"
    }
  }, [_vm._v("Slab Rate")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ratetype')),
      expression: "errors.has('ratetype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Tariff Card Rate Type.")])], 1), _vm._v(" "), (_vm.showslabtemp == true && _vm.ratetype == 'slab' && _vm.tariffcardratebasis != '') ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Slab Type "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tariffcardslabtype),
      expression: "tariffcardslabtype"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "id": "SlabWeight",
      "value": "1",
      "name": "tariffcardslabtype"
    },
    domProps: {
      "checked": _vm._q(_vm.tariffcardslabtype, "1")
    },
    on: {
      "click": _vm.filterSlabList,
      "__c": function($event) {
        _vm.tariffcardslabtype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "slabWeight"
    }
  }, [_vm._v("Weight (kg)")]), _vm._v("   \n                    "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tariffcardslabtype),
      expression: "tariffcardslabtype"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('slabType')
    },
    attrs: {
      "type": "radio",
      "disabled": _vm.tariffcardratebasis != 2,
      "id": "SlabQuantity",
      "value": "2",
      "name": "tariffcardslabtype"
    },
    domProps: {
      "checked": _vm._q(_vm.tariffcardslabtype, "2")
    },
    on: {
      "click": _vm.filterSlabList,
      "__c": function($event) {
        _vm.tariffcardslabtype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "slabQuantity"
    }
  }, [_vm._v("Quantity (Number of boxes)")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('tariffcardslabtype')),
      expression: "errors.has('tariffcardslabtype')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Tariff Card Slab Type.")])], 1) : _vm._e(), _vm._v(" "), (_vm.showslabtemp == true && _vm.tariffcardslabtype != '') ? _c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Choose Slab Template "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-wpforms'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.slablist,
      "placeholder": "Select Slab",
      "name": "Slab",
      "append-to-body": true,
      "disabled": false
    },
    on: {
      "select": _vm.selectslab
    },
    model: {
      value: (_vm.selectedslab.id),
      callback: function($$v) {
        _vm.selectedslab.id = $$v
      },
      expression: "selectedslab.id"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Slab')),
      expression: "errors.has('Slab')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select Slab Template.")])], 1) : _vm._e()]), _vm._v(" "), (_vm.showmatrix == true && _vm.validatedData[0] && _vm.ratetype == 'flat' && _vm.ratetype != '') ? _c('b-card', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Upload Rate")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "color": "#fff",
      "cursor": "pointer"
    },
    attrs: {
      "for": "FileUpload"
    }
  }, [_c('a', {
    staticClass: "-btn btn-primary"
  }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "FileUpload",
      "accept": ".csv",
      "name": "FileUpload",
      "value": "file",
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.chooseFile($event, 0)
      }
    }
  }), _vm._v("  \n                      "), _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Chosen File: " + _vm._s(_vm.validatedData[0].filename))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('uploadform.FileUpload')),
      expression: "errors.has('uploadform.FileUpload')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Choose file to upload")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    staticStyle: {
      "float": "left",
      "padding-right": "2px",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": _vm.validatedData[0].downloadLabel
    },
    on: {
      "click": _vm.downloadTariff
    }
  }, [_vm._v(_vm._s(_vm.validatedData[0].downloadLabel))])])]), _vm._v(" "), (_vm.validatedData[0].isfilechose) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.validatedData[0].isDisable,
      "title": "Validate File"
    },
    on: {
      "click": function($event) {
        _vm.validateTariff(0, 0)
      }
    }
  }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[0].isvalidationdone) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.ratetype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.servicetype == 2 && _vm.validatedData[0].isvalidationdone) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_c('span', [_vm._v("Total Service Level Template Records: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.serviceTemplateCount))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.validatedData[0].isvalidationdone) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.validatedData[0].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedData[0].validdata))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedData[0].invaliddata))])])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[0].isvalidationdone) ? _c('div', {
    staticClass: "form-group row"
  }, [(_vm.servicetype == 2) ? _c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_c('span', [_vm._v("Total Service Level Template Records not present in file: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.validatedData[0].notpresentdata))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.validatedData[0].invaliddata > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Invalid records details:")])])]) : _vm._e(), _vm._v(" "), ((_vm.validatedData[0].invaliddata > 0 || _vm.validatedData[0].notpresentdata > 0) && (_vm.validatedData[0].invalid18x18Data.length > 0 || _vm.validatedData[_vm.index].notpresentdata > 0) && _vm.servicetype == 2) ? _c('div', {
    staticClass: "modal-bodyfrm",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('h6', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "0px"
    }
  }, [_vm._v("Invalid Records")]), _vm._v(" "), _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4",
      "color": "white"
    }
  }, [_vm._v("Origin Zone")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4",
      "color": "white"
    }
  }, [_vm._v("Destination Zone")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4",
      "color": "white"
    }
  }, [_vm._v("Rate ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "background-color": "#4185f4",
      "color": "white"
    }
  }, [_vm._v("Error Message ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.validatedData[0].invalid18x18Data), function(data, index) {
    return (_vm.validatedData[0].invalid18x18Data.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(data.originzone))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationzone))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.TAT))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.msg))])]) : _vm._e()
  }), _vm._v(" "), (_vm.validatedData[0].invalid18x18Data.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[0].invaliddata > 0 && _vm.servicetype == 1) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumnFlat,
      "items": _vm.validatedData[0].tableItems,
      "offset": _vm.validatedData[0].offset
    }
  }), _vm._v(" "), _c('pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validatedData[0].totalPage > 1),
      expression: "validatedData[0].totalPage>1"
    }],
    staticClass: "slabPagination",
    attrs: {
      "total-pages": _vm.validatedData[0].totalPage,
      "total": _vm.validatedData[0].totalCount,
      "per-page": _vm.validatedData[0].pageLimit,
      "current-page": _vm.validatedData[0].currentPage
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange($event, 0)
      }
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.slabtype != '' && _vm.selectedslab.id) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Define Rate")]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.matrixSlabHeaderArray), function(val, index) {
    return _c('div', {
      staticClass: "tab"
    }, [_c('input', {
      staticClass: "hide",
      attrs: {
        "type": "checkbox",
        "id": 'chck' + val.id
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "tab-label",
      attrs: {
        "for": 'chck' + val.id
      }
    }, [_vm._v("Break " + _vm._s(val.id) + " " + _vm._s(_vm.tariffcardslabtype == 1 ? '(Billable weight (kg)' : '(Quantity (Number of boxes))') + ": " + _vm._s(val.name) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "tab-content",
      staticStyle: {
        "overflow": "auto",
        "overflow-x": "auto"
      }
    }, [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_vm._v("Upload Rate")]), _vm._v(" "), _c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'FileUpload' + index
      }
    }, [_c('a', {
      staticClass: "-btn btn-primary"
    }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
      ref: "files",
      refInFor: true,
      attrs: {
        "accept": ".csv",
        "id": 'FileUpload' + index,
        "name": "FileUpload",
        "type": "file"
      },
      on: {
        "change": function($event) {
          _vm.chooseFile($event, index, 1)
        }
      }
    }), _vm._v("  \n                              "), _c('span', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("Chosen File: " + _vm._s(_vm.validatedData[index].filename))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('uploadform.FileUpload')),
        expression: "errors.has('uploadform.FileUpload')"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Choose file to upload")])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      staticStyle: {
        "cursor": "pointer",
        "float": "left"
      },
      attrs: {
        "type": "button",
        "title": _vm.validatedData[index].downloadLabel
      },
      on: {
        "click": function($event) {
          _vm.downloadTariff(val)
        }
      }
    }, [_vm._v(_vm._s(_vm.validatedData[index].downloadLabel))])])]), _vm._v(" "), (_vm.validatedData[index].isfilechose) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "disabled": _vm.validatedData[index].isDisable,
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateTariff(val, index)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].isvalidationdone) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].isvalidationdone) ? _c('div', {
      staticClass: "form-group row"
    }, [(_vm.servicetype == 2) ? _c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Service Level Template Records:  ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.serviceTemplateCount))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].isvalidationdone) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.validatedData[index].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.validatedData[index].validdata))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.validatedData[index].invaliddata))])])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].isvalidationdone) ? _c('div', {
      staticClass: "form-group row"
    }, [(_vm.servicetype == 2) ? _c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Service Level Template Records not present in file:  ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.validatedData[index].notpresentdata))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].invaliddata > 0) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid records details:")]), _vm._v(" "), _c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "float": "right",
        "padding-right": "2px",
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "title": "Download (CSV)"
      },
      on: {
        "click": function($event) {
          _vm.downloadInvalidData(index)
        }
      }
    }, [_vm._v("Download (CSV)")])])]) : _vm._e(), _vm._v(" "), ((_vm.validatedData[index].invaliddata > 0 || _vm.validatedData[index].notpresentdata > 0) && (_vm.validatedData[index].invalid18x18Data.length > 0 || _vm.validatedData[index].notpresentdata > 0) && _vm.servicetype == 2) ? _c('div', {
      staticClass: "modal-bodyfrm",
      staticStyle: {
        "overflow": "auto"
      }
    }, [((_vm.validatedData[index].invaliddata > 0 || _vm.validatedData[index].notpresentdata > 0) && (_vm.validatedData[index].invalid18x18Data.length > 0 || _vm.validatedData[index].notpresentdata > 0) && _vm.servicetype == 2) ? _c('h6', {
      staticStyle: {
        "text-align": "center",
        "margin-bottom": "0px"
      }
    }, [_vm._v("Invalid Records")]) : _vm._e(), _vm._v(" "), _c('table', {
      staticClass: "styled-table",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('thead', [_c('tr', {
      staticClass: "text-primary"
    }, [_c('th', {
      staticClass: "text-center",
      staticStyle: {
        "background-color": "#4185f4",
        "color": "white"
      }
    }, [_vm._v("Origin Zone")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "background-color": "#4185f4",
        "color": "white"
      }
    }, [_vm._v("Destination Zone")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "background-color": "#4185f4",
        "color": "white"
      }
    }, [_vm._v("Rate ")]), _vm._v(" "), _c('th', {
      staticClass: "text-center",
      staticStyle: {
        "background-color": "#4185f4",
        "color": "white"
      }
    }, [_vm._v("Error Message ")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.validatedData[index].invalid18x18Data), function(data, index1) {
      return (_vm.validatedData[index].invalid18x18Data.length > 0 && _vm.servicetype == 2) ? _c('tr', [_c('td', {
        staticClass: "text-center",
        attrs: {
          "scope": "row"
        }
      }, [_vm._v(_vm._s(data.originzone))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.destinationzone))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.TAT))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(data.msg))])]) : _vm._e()
    }), _vm._v(" "), (_vm.validatedData[index].invalid18x18Data.length < 1 && _vm.servicetype == 2) ? _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "10"
      }
    }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].invaliddata > 0 && _vm.servicetype == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.tableColumnSlab,
        "items": _vm.validatedData[index].tableItems,
        "offset": _vm.validatedData[index].offset
      }
    }), _vm._v(" "), _c('pagination', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validatedData[index].totalPage > 1),
        expression: "validatedData[index].totalPage>1"
      }],
      staticClass: "slabPagination",
      attrs: {
        "total-pages": _vm.validatedData[index].totalPage,
        "total": _vm.validatedData[index].totalCount,
        "per-page": _vm.validatedData[index].pageLimit,
        "current-page": _vm.validatedData[index].currentPage
      },
      on: {
        "pagechanged": function($event) {
          _vm.onPageChange($event, index)
        }
      }
    })], 1) : _vm._e()])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.selectedservice.id && _vm.validatedData.length > 0 && _vm.validatedData[0].isvalidationdone && _vm.validatedData[0].notpresentdata == 0) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    staticStyle: {
      "cursor": "pointer",
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Save"
    },
    on: {
      "click": _vm.validateTariffCard
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]) : _vm._e()], 1)])], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-119f9df6","hasScoped":true}!./src/modules/masterdata/views/tariffcard/createtariffcard/createtariffcard.component.html
// module id = 787
// module chunks = 3